import { createFileRoute } from '@tanstack/react-router'

import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'
import { GenerateQuoteFailedPage } from '../../../modules/quote/back-office/generate-quote/generate-quote-failed-page.tsx'

export const Route = createFileRoute('/bo/subscriptions/generate-failed')({
  component: () => (
    <PermissionChecker requiredPermissions={['subscription.create']}>
      <GenerateQuoteFailedPage />
    </PermissionChecker>
  ),
})
